'use client'

import Arrow from '@local/assets/svgs/arrow.svg'
import {useTranslate} from '@local/hooks'
import {Button, ButtonProps} from '@local/ui/components'
import {cx} from '@local/utils/cx'

interface CounterProps {
	className?: string,
	buttonClassName?: string,
	buttonVariant?: ButtonProps['variant']
	loop?: boolean
	buttonState?: -1 | 0 | 1
	onPrev?: () => void
	onNext?: () => void
}

export const PrevNextNavigation = ({
	className,
	loop = false,
	buttonClassName,
	buttonState = -1,
	buttonVariant = 'icon',
	onPrev,
	onNext,
}: CounterProps) => {
	const translate = useTranslate()

	return (
		<div className={cx(
			'flex items-center justify-end',
			'mt-10',
			'pointer-events-none',
			className,
		)}>
			<Button
				type='button'
				border
				disabled={!loop && buttonState === -1}
				onClick={onPrev}
				className={cx(
					'pointer-events-auto',
					buttonClassName,
				)}
				variant={buttonVariant}
				label={translate('Previous')}>
				<Arrow className={cx('scale-[-1] w-6 h-9', !loop && buttonState === -1 && 'opacity-60')} />
			</Button>
			<Button
				type='button'
				border
				disabled={!loop && buttonState === 1}
				onClick={onNext}
				className={cx(
					'ml-10',
					'pointer-events-auto',
					buttonClassName,
				)}
				variant={buttonVariant}
				label={translate('Next')}>
				<Arrow className={cx('w-6 h-9', !loop && buttonState === 1 && 'opacity-60')} />
			</Button>
		</div>
	)
}
